export default __webpack_public_path__ + "static/media/Taro.3bc7bccd.png";